import { cva } from 'class-variance-authority';

export const styles = cva(['grid place-items-center', 'motion-safe:transition-colors motion-safe:duration-300 motion-reduce:transition-none'], {
  variants: {
    color: {
      brand: ['bg-brand-100 text-brand-600'],
      gray: ['bg-gray-100 text-gray-600'],
      error: ['bg-red-100 text-red-600'],
      warning: ['bg-yellow-100 text-yellow-600'],
      success: ['bg-green-100 text-green-600'],
    },
    size: {
      sm: ['size-8 p-2', '[&>svg]:size-4'],
      md: ['size-10 p-2.5', '[&>svg]:size-5'],
      lg: ['size-12 p-3', '[&>svg]:size-6'],
      xl: ['size-14 p-4', '[&>svg]:size-8'],
    },
    type: {
      light: 'rounded-full',
      dark: 'rounded-lg',
      modern: 'rounded-lg border border-primary-border bg-primary-background text-secondary-700',
    },
  },
  defaultVariants: {
    color: 'brand',
    size: 'md',
    type: 'light',
  },
});
